import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "fixed top-6 right-6 z-[9999] w-[360px] max-w-[92vw] pointer-events-none" }
const _hoisted_2 = { class: "flex-1 text-sm font-medium" }

import { useToastNotificationStore } from "@/stores/toastNotificationStore";
import { Toast } from "@/types/toast";
import ToastCloseIcon from "@/components/notifications/ToastCloseIcon.vue";
import SuccessNotificationIcon from "@/components/notifications/SuccessNotificationIcon.vue";
import ErrorNotificationIcon from "@/components/notifications/ErrorNotificationIcon.vue";
import WarningNotificationIcon from "@/components/notifications/WarningNotificationIcon.vue";
import InfoNotificationIcon from "@/components/notifications/InfoNotificationIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationComponent',
  setup(__props) {

const notificationStorage = useToastNotificationStore();

function removeToast(id: number) {
  notificationStorage.removeNotification(id);
}

function getToastClasses(toast: Toast) {
  switch (toast.type) {
    case "error":
      return "bg-red-700 text-red-50";
    case "success":
      return "bg-green-700 text-green-50";
    default:
      return "bg-yellow-500 text-yellow-50";
  }
}

function getToastIcon(toast: Toast) {
  switch (toast.type) {
    case "error":
      return ErrorNotificationIcon;
    case "success":
      return SuccessNotificationIcon;
    case "warning":
      return WarningNotificationIcon;
    case "info":
      return InfoNotificationIcon;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "toast",
        tag: "div",
        "move-class": "transition-all duration-300",
        class: "flex flex-col gap-y-3"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationStorage).notifications, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(["flex items-center gap-3 rounded-lg p-4", getToastClasses(toast)])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(getToastIcon(toast)), { class: "h-full aspect-square" })),
              _createElementVNode("div", _hoisted_2, _toDisplayString(toast.text), 1),
              _createVNode(ToastCloseIcon, {
                class: "cursor-pointer size-5 pointer-events-auto",
                onClick: ($event: any) => (removeToast(toast.id))
              }, null, 8, ["onClick"])
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})